<script setup lang="ts">
import type { Media } from "@/models"
import { computed } from "vue"
import { BaseModal, Icon } from "@/components/ui"
import { useModal, useTranslation } from "@/composables"
import { WelcomeVideoModalKey } from "@/symbols"

const props = defineProps<{
  media?: Media
  videoUrl?: string
  posterUrl?: string
}>()

const videoSource = computed(() => props.videoUrl ?? props.media?.thumbnailUrl)
const posterSource = computed(() => props.posterUrl ?? props.media?.getThumbnailUrl())

const { toggle } = useModal(WelcomeVideoModalKey)
const { t } = useTranslation()
</script>

<template>
  <BaseModal :name="WelcomeVideoModalKey">
    <div class="gpx-welcome-modal-content">
      <div class="relative inline-block max-w-full">
        <video v-if="videoSource" autoplay playsinline :poster="posterSource" controls>
          <source :src="videoSource" type="video/mp4">
        </video>
        <button
          type="button"
          class="cursor-pointer absolute right-2 top-2 flex size-10 items-center justify-center rounded-full bg-white/90 text-neutral-800 shadow-md transition hover:bg-white focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-neutral-900"
          :aria-label="t('welcome_video_modal.close')"
          @click="toggle"
        >
          <Icon icon="Close" aria-hidden />
        </button>
      </div>
    </div>
  </BaseModal>
</template>

<style scoped>
video {
  max-height: 80vh;
  width: 100%;
  object-fit: contain;
}

.gpx-welcome-modal-content {
  display: flex;
  justify-content: center;
}
</style>
